import React, {
  useCallback,
  useContext,
  useState
} from 'react';

import add from 'date-fns/add';

import {
  AGGREGATION_MODE,
  AGGREGATION_TYPE,
  BIN_MODE,
  METRIC_TYPE,
  MONITORING_PATH,
  SCHEDULING_MODE,
} from '../../constants/assay.constants';

import createAssay from '../../utils/api_functions/assayCreation';
import { newAssayConfiguration } from '../../utils/assay_utils';

const AssayCreationContext = React.createContext({
  assayName: '',
  pipelineID: '',
  iopath: MONITORING_PATH.INPUT,
  aggregation: AGGREGATION_MODE.CUMULATIVE,
  aggType: AGGREGATION_TYPE.UNIVARIATE,
  metric: METRIC_TYPE.PSI,
  binMode: BIN_MODE.QUANTILE,
  schedulingMode: SCHEDULING_MODE.DAILY,
  alertThreshold: 1,
  baselineStart: null,
  baselineEnd: null,
  windowStart: null,
  windowEnd: null,
  finishAndCreate: () => { },
  setAssayPropertyByKey: () => { },
});

export const AssayCreationProvider = ({
  children, pipelineID, pipelineName, workspaceID,
}) => {
  const today = new Date();
  const yesterday = add(new Date(), { days: -1 });

  const [assayPropertyMap, setAssayPropertyMap] = useState({
    assayName: '',
    iopath: MONITORING_PATH.INPUT,
    aggregation: AGGREGATION_MODE.CUMULATIVE,
    aggType: AGGREGATION_TYPE.UNIVARIATE,
    metric: METRIC_TYPE.PSI,
    binMode: BIN_MODE.QUANTILE,
    schedulingMode: SCHEDULING_MODE.DAILY,
    alertThreshold: 1,
    baselineStart: yesterday,
    windowStart: yesterday,
    baselineEnd: today,
    windowEnd: today,
  });

  const setAssayPropertyByKey = useCallback((key, value) => {
    setAssayPropertyMap({
      ...assayPropertyMap,
      [key]: value,
    })
  }, [assayPropertyMap]);

  // TODO - add function for retrieving baseline
  // TODO - add function for retrieving run preview with current assay configuration

  const finishAndCreate = useCallback(() => {
    // TODO - Map properties to new assay config option and create
    const assayConfig = newAssayConfiguration({
      pipelineID, pipelineName, workspaceID, configMap: assayPropertyMap
    });
    createAssay(assayConfig);
  }, [assayPropertyMap, pipelineID, pipelineName, workspaceID]);

  return (
    <AssayCreationContext.Provider
      value={{
        assayName: assayPropertyMap.assayName,
        iopath: assayPropertyMap.iopath,
        aggregation: assayPropertyMap.aggregation,
        aggType: assayPropertyMap.aggType,
        metric: assayPropertyMap.metric,
        binMode: assayPropertyMap.binMode,
        schedulingMode: assayPropertyMap.schedulingMode,
        alertThreshold: assayPropertyMap.alertThreshold,
        baselineStart: assayPropertyMap.baselineStart,
        baselineEnd: assayPropertyMap.baselineEnd,
        windowStart: assayPropertyMap.windowStart,
        windowEnd: assayPropertyMap.windowEnd,
        setAssayPropertyByKey,
        finishAndCreate,
      }}
    >
      {children}
    </AssayCreationContext.Provider>
  )
}

export const useAssayCreationContext = () => useContext(AssayCreationContext);

export default useAssayCreationContext;
